import React from "react";
type SectionHeadingProps = {
  eyebrow?: string;
  title: string;
  copy?: string;
  align?: "left" | "center";
  light?: boolean;
  className?: string;
  id?: string;
};
function SectionHeading({
  eyebrow,
  title,
  copy,
  align = "left",
  light = false,
  className = "",
  id
}: SectionHeadingProps) {
  return <div className={`${align === "center" ? "mx-auto text-center" : ""} max-w-3xl ${className}`} data-id="element-211" data-mp="363cioyhyzdlc">
      {eyebrow ? <p className={`section-label mb-2.5 ${light ? "text-pfpc-orange" : "text-pfpc-steel"}`} data-id="element-212" data-mp="3b1e3poyyhmzg">
          {eyebrow}
        </p> : null}
      <h2 id={id} className={`font-heading text-[28px] font-extrabold leading-[1.15] md:text-[36px] md:leading-[1.12] ${light ? "text-pfpc-offwhite" : "text-pfpc-navy"}`} data-id="element-213" data-mp="3ju7tigc144rk">
        {title}
      </h2>
      {copy ? <p className={`mt-3 max-w-[68ch] text-[16px] leading-7 md:text-[17px] ${light ? "text-pfpc-offwhite/75" : "text-pfpc-navy/72"}`} data-id="element-214" data-mp="3tsx6bup2iz0y">
          {copy}
        </p> : null}
    </div>;
}
export { SectionHeading };